import { RouteObject } from "react-router-dom";

export const incidentsRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Incidents" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { IncidentsPage } = await import("./incidents-page");
          return { Component: IncidentsPage };
        },
      },
    ],
  },
];
